import React from "react";
import BootstrapDropDown from "bootstrap/js/dist/dropdown"

export const DropDownContainer = ({ children }: { children: (toggle: () => void) => React.ReactNode }) => {

    const containerRef = React.useRef<HTMLSpanElement>(null);
    let dropDown: BootstrapDropDown | null = null
    React.useEffect(() => {
        if (!containerRef.current)
            return;
        const toggle = containerRef.current!.querySelector(".dropdown-toggle") ?? containerRef.current!.querySelector(".dropdowncontainer-toggle");
        dropDown = toggle
            ? BootstrapDropDown.getOrCreateInstance(toggle,
                {
                    autoClose: true,
                })
            : null
    })
    return <span ref={containerRef}>{children(() => dropDown?.toggle())}</span>
}

export const DropDownMenu = ({ toggle, children, additionalClassName, additionalMenuClassName }: {
    toggle: React.ReactNode,
    children: (className: string) => React.ReactNode,
    additionalClassName?: string,
    additionalMenuClassName?: string,
}) => {

    return (
        <DropDownContainer>
            {
                toggleDropDown =>
                    <div className={"dropdown" + (additionalClassName ? ` ${additionalClassName}` : "")}>
                        <a
                            className="nav-link dropdown-toggle d-flex align-items-center"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={toggleDropDown}
                        >
                            {toggle}
                        </a>
                        <ul className={"dropdown-menu" + (additionalMenuClassName ? ` ${additionalMenuClassName}` : "")}>
                            {children("dropdown-item")}
                        </ul>
                    </div>
            }
        </DropDownContainer>
    );
}